import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import _ from "lodash";
import axios from "axios";
import { TokenService } from "@/api/storage";

@Component
export class ActionMixin extends Vue {
  @Action("showAlertNotification") showAlertNotification: any;
  async withLoading(p: () => Promise<any>): Promise<void> {
    try {
      return await p();
    } catch (e: any) {
      // Não exibir alerta se a requisição foi cancelada
      if (e?.message === "canceled" || axios.isCancel(e)) {
        return Promise.reject(e);
      }

      // Não exibir alerta se for erro 403 em rota não autenticada e sem token
      const currentToken = TokenService.getToken();
      const currentRoute = this.$route;
      const requiresAuth = currentRoute?.meta?.requiresAuth !== false;

      // Se erro 403, sem token E rota não requer autenticação = não exibir alerta
      if (e.response?.status === 403 && !currentToken && !requiresAuth) {
        return Promise.reject(e);
      }

      const messageDefaultError = this.$t("toast.errorText");
      const messageDefaultTitle = this.$t("toast.error");
      const title = e.response?.data?.title || messageDefaultTitle;
      const message =
        e.response?.status === 401
          ? this.$t("misc.expiredToken")
          : _.isString(e.response?.data)
          ? e.response?.data.length > 0
            ? e.response?.data
            : messageDefaultError
          : e.response?.data?.message || messageDefaultError;
      this.showAlertNotification({
        message: message,
        color: "redAlert",
        icon: "cancel",
        title: title,
      });
      return Promise.reject(e);
    }
  }
}
